import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

import {
  blue_star,
  Dashboard_active,
  Dashboard_de,
  Login_title,
  Regional_active,
  Regional_de,
  Roles_active,
  Roles_de,
  service_active,
  service_deactive,
  unblue_star,
} from "../assets/img";
import LogoutIcon from "@mui/icons-material/Logout";
import FlutterDashIcon from "@mui/icons-material/FlutterDash";
import { URLS } from "../Screen/redux/api/Constants";
import { post } from "../Screen/redux/api/ApiHandler";

const Profilenavbar2 = ({ setSaidList }) => {
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const toggleSidebar = () => {
    setSaidBarShow(!saideBarShow);
    setActiveMenu(null);
  };

  const handleMenuClick = (menuKey, defaultRoute) => {
    setSaidBarShow(true);
    setActiveMenu((prev) => (prev === menuKey ? null : menuKey));
    if (activeMenu !== menuKey && defaultRoute) {
      navigate(defaultRoute);
    }
  };

  const handleLogout = () => {
    setLoading(true);
    // Simulated logout logic; replace with API call as needed
    setTimeout(() => {
      localStorage.clear();
      setLoading(false);
      setPopup(false);
      navigate("/");
    }, 1000);
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const fetchNotification = async () => {
    let payload = {
      page: 1,
      search: "",
      rows: 10,
      order: "desc",
      from_date: "",
      to_date: "",
      title: "",
    };
    let res = await post(URLS.NOTICATION, payload);
    console.log("conutRes", res);
    if (res?.status == "success") {
      setCount(res?.pagination?.total);
    }
  };

  // Scroll to bottom when menu opens
  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const el = menuRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    }
    fetchNotification();
  }, [menuOpen, navigate]);

  return (
    <div className={`${saideBarShow ? "sidebar" : "close_sidebar"}`}>
      <header>
        <div className="image_text pointer d-flex ac-jc p-2 mt-2 Header_title">
          {saideBarShow ? (
            // When sidebar is expanded — show logo
            <img src={Login_title} className="Login_title1" alt="logo" />
          ) : (
            // When sidebar is minimized — show FlutterDashIcon
            <FlutterDashIcon
              className="FlutterDashIcon"
              style={{ fontSize: 40 }}
            />
          )}
        </div>
      </header>

      <div onClick={toggleSidebar}>
        {saideBarShow ? (
          <KeyboardDoubleArrowLeftIcon className="arrow-right" />
        ) : (
          <KeyboardDoubleArrowRightIcon className="arrow-left" />
        )}
      </div>

      <div ref={menuRef} className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("dashboard1", "/dashboard1")}
            >
              <h4
                className={`ps-3 ${
                  ["dashboard1"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["dashboard1"].includes(splitLocation[1])
                      ? Dashboard_active
                      : Dashboard_de
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Dashboard
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("ticket2", "/pending2")}
            >
              <h4
                className={`ps-3 ${
                  [
                    "ticket2",
                    "Pending2",
                    "ticket-closed-table",
                    "pending2",
                    "Work-completed-table",
                    "table-inventory",
                    "view-inventory",
                    "view-technical",
                    "ticket-closed-view",
                    "dispatch-table",
                    "dispatch-view",
                    "view-dispatch",
                    "delivery-table",
                    "delivery-view",
                    "table-technical",
                    "Work-completed-view",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : "region"
                }`}
              >
                <img
                  src={
                    [
                      "ticket2",
                      "Pending2",
                      "ticket-closed-table",
                      "pending2",
                      "Work-completed-table",
                      "table-inventory",
                      "view-inventory",
                      "view-technical",
                      "ticket-closed-view",
                      "dispatch-table",
                      "dispatch-view",
                      "view-dispatch",
                      "delivery-table",
                      "delivery-view",
                      "table-technical",
                      "Work-completed-view",
                    ].includes(splitLocation[1])
                      ? blue_star
                      : unblue_star
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Ticket <KeyboardArrowDownOutlinedIcon />
                </span>
              </h4>
            </li>
            {activeMenu === "ticket2" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/pending2")}
                >
                  <h4
                    className={`${
                      [
                        "pending2",
                        "table-inventory",
                        "view-inventory",
                        "dispatch-table",
                        "dispatch-view",
                        "delivery-table",
                        "delivery-view",
                        "table-technical",
                        "view-dispatch",
                      ].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Pending Ticket
                  </h4>
                </li>

                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/Work-completed-table")}
                >
                  <h4
                    className={`${
                      [
                        "Work-completed-table",
                        "Work-view",
                        "work-move",
                        "view-technical",
                        "Work-completed-view",
                      ].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Work Completed
                  </h4>
                </li>
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/ticket-closed-table")}
                >
                  <h4
                    className={`${
                      ["ticket-closed-table", "ticket-closed-view"].includes(
                        splitLocation[1]
                      )
                        ? "f3 sub_active"
                        : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Closed Ticket
                  </h4>
                </li>
              </ul>
            )}
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("report-inv", "/report-inv")}
            >
              <h4
                className={`ps-3 ${
                  ["report-inv", "report-list-inv"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : "region"
                }`}
              >
                <img
                  src={
                    ["report-inv", "report-list-inv"].includes(splitLocation[1])
                      ? blue_star
                      : unblue_star
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Report {/*  <KeyboardArrowDownOutlinedIcon /> */}
                </span>
              </h4>
            </li>
            {/* {activeMenu === "report-inv" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/report-inv")}
                >
                  <h4
                    className={`${
                      ["/report-inv", "report-list-inv"].includes(
                        splitLocation[1]
                      )
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Report
                  </h4>
                </li>

              </ul>
            )} */}
            {/* <li
              className="nav_link trans"
              onClick={() => navigate("/in-notification")}
            >
              <h4
                className={`ps-3 ${
                  ["in-notification"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <div className="notification-wrapper">
                  <NotificationsActiveIcon className="icon" />
                  {count > 0 && (
                    <span className="notification-badge"
                    >
                      {count > 99 ? "99+" : count}
                    </span>
                  )}
                </div>
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Notification
                </span>
              </h4>
            </li> */}
            <li
              className="nav_link trans"
              onClick={() => navigate("/in-notification")}
            >
              <h4
                className={`ps-3 d-flex align-items-center ${
                  ["in-notification"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <div className="notification-wrapper">
                  <NotificationsActiveIcon className="icon" />
                  {count > 0 && (
                    <span className="notification-badge">
                      {count > 99 ? "99+" : count}
                    </span>
                  )}
                </div>

                <span className="text text-nowrap f3 ms-2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                  Notification
                </span>
              </h4>
            </li>
          </ul>
        </div>
      </div>

      {/* Logout Button */}
      <div
        style={{ cursor: "pointer" }}
        className="d-flex ac-jb py-3 px-2 bg-primary2"
        onClick={() => setPopup(true)}
      >
        <h4 className="f4 fs-md-13 fs-xl-16 mb-0 ms-4">Logout</h4>
        <LogoutIcon />
      </div>

      {/* Logout Confirmation Popup */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 mt-4 mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
              Are you sure you want to <LogoutIcon /> logout?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => setPopup(false)}
                className="no-btn f2 w-40"
              >
                No
              </button>
              <button onClick={handleLogout} className="yes-btn f2 w-40">
                {loading ? "Loading..." : "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profilenavbar2;
